<div class="c-card" >
  <div class="c-card__header">
      <div [class]="'e-badge u-fs-14 ' + cardData.tag.tag_type">
        {{ cardData.tag.tag_label }}
      </div>
  </div>
  <div [class]="'c-card__body' + customClass" select="[body]">
    <ng-content></ng-content>
    @if(cardData.button != null) {
      <div class="element">
        <button 
          [class]="cardData.button.button_class + ' p-flexcc u-gap-8 i-fs-16 u-fw-500 u-size-per-100'"
          ngClass=''
          (click)="onButtonClick()">
          <p class="aig-header__logout">{{cardData.button.button_label}}</p>
        </button>
      </div>
    }
  </div>
</div>